import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollCustomFieldDefinitionResponse, PayrollUpdateCustomFieldRequest } from '../types';

export const updateCustomFieldMutation = gql`
  mutation PayrollUpdateCustomField($fieldKey: String!, $input: PayrollUpdateCustomFieldInput!) {
    payrollUpdateCustomField(fieldKey: $fieldKey, input: $input) {
      id
      fieldKey
      label
      valueType
      origin
      isRequired
      enumValues
      usages
      section
      displayOrder
      accessPolicy
    }
  }
`;

export const updateCustomField = (queryVariables: PayrollUpdateCustomFieldRequest) =>
  graphQLApi<PayrollCustomFieldDefinitionResponse<'payrollUpdateCustomField'>, PayrollUpdateCustomFieldRequest>({
    query: updateCustomFieldMutation,
    queryVariables,
  });
